import { FC, PropsWithChildren, useMemo } from 'react';
import { MainLayoutContext } from '../model/context';
import { MainLayoutContextType } from '../model/types';
import { useMainBreadcrumbs } from '../model/useMainBreadcrumbs';
import { useMainControls } from '../model/useMainControls';
import { useMainSidebar } from '@/shared/ui/MainLayoutProvider/model/useMainSidebar';

export const MainLayoutProvider: FC<PropsWithChildren> = ({ children }) => {
  const breadcrumbs = useMainBreadcrumbs();
  const controls = useMainControls();
  const sidebar = useMainSidebar();

  const value = useMemo<MainLayoutContextType>(
    () => ({
      breadcrumbs,
      controls,
      sidebar,
    }),
    [breadcrumbs, sidebar],
  );

  return <MainLayoutContext.Provider value={value}>{children}</MainLayoutContext.Provider>;
};
